import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import userActions from '../../redux/user/actions'

class ModalConfirmBan extends Component {
    _handleOK = () => {
        this.props.dismiss()
        this.props.banUser(this.props.user.uid)
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Xác nhận xoá người dùng"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[
                    <Button
                        key="back"
                        size="large"
                        type="primary"
                        onClick={() => this._handleCancel()}
                    >
                        Huỷ
                    </Button>,
                    <Button
                        key="submit"
                        size="large"
                        type="danger"
                        onClick={() => this._handleOK()}
                    >
                        Cấm
                    </Button>,
                ]}
            >
                <p>Bạn có chắc chắn cấm người dùng này không?</p>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.currentUser,
        visible: state.user.modalConfirmBanState,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(userActions.action.dismissModalConfirmBanUser())
        },
        banUser: userId => {
            dispatch(userActions.action.banUser(userId))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalConfirmBan)
